import { getQueryParam } from './query/getQueryParam.js';
import { getQueryParams } from './query/getQueryParams.js';
import { toQueryString } from './query/toQueryString.js';

export class LocationProvider {
  constructor(locationObject = location) {
    this.locationObject = locationObject;
  }

  get hash() {
    return this.locationObject.hash;
  }

  set hash(value) {
    if (value && !value.startsWith('#')) {
      value = `#${value}`;
    }

    this.locationObject.hash = value;
  }

  get search() {
    return this.locationObject.search;
  }

  set search(value) {
    if (value && !value.startsWith('?')) {
      value = `?${value}`;
    }

    this.locationObject.search = value;
  }

  get pathname() {
    return this.locationObject.pathname;
  }

  set pathname(value) {
    this.locationObject.pathname = value;
  }

  get href() {
    return this.locationObject.href;
  }

  set href(value) {
    this.locationObject.href = value;
  }

  get queryParams() {
    return getQueryParams(this.search);
  }

  getQueryParam(queryParam) {
    return getQueryParam(queryParam, this.search);
  }

  setQueryParam(queryParam, value) {
    const { queryParams } = this;
    queryParams[queryParam] = value;

    this.search = toQueryString(queryParams);
  }

  reload() {
    this.locationObject.reload();
  }
}
  
export const locationProvider = new LocationProvider();